var React = require('react');

function IconMagnifyingGlassChart (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"fill":"currentColor","d":"M13.813 6.906a6.89 6.89 0 0 1-1.329 4.074l4.204 4.207a1.064 1.064 0 0 1-1.504 1.504l-4.204-4.207a6.867 6.867 0 0 1-4.074 1.329A6.905 6.905 0 0 1 0 6.905 6.905 6.905 0 0 1 6.906 0a6.905 6.905 0 0 1 6.907 6.906Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h17v17H0z"})))]);
}

IconMagnifyingGlassChart.defaultProps = {"viewBox":"0 0 17 17"};

module.exports = IconMagnifyingGlassChart;

IconMagnifyingGlassChart.default = IconMagnifyingGlassChart;
